'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function ClientErrorLogger() {
  const pathname = usePathname();

  useEffect(() => {
    const onError = (event: ErrorEvent) => {
      console.error('[ClientError]', {
        pathname,
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        error: event.error,
      });
    };

    const onRejection = (event: PromiseRejectionEvent) => {
      console.error('[UnhandledRejection]', { pathname, reason: event.reason });
    };

    window.addEventListener('error', onError);
    window.addEventListener('unhandledrejection', onRejection);

    return () => {
      window.removeEventListener('error', onError);
      window.removeEventListener('unhandledrejection', onRejection);
    };
  }, [pathname]);

  return null;
}
